<template>
  <div class="types">
    <div
      class="item"
      v-for="item in serviceTypes"
      :key="item.type"
      :type="item.type"
      @click="gotoType(item)"
    >
      <img :src="item.icon" alt="" />
      <div class="item-content">
        <div class="name">{{ item.name }}</div>
        <div class="info">等服务</div>
      </div>
    </div>
  </div>
</template>
<script>
import { httpOpen } from "../../scripts/network";
export default {
  name: "ChooseServiceType",
  data() {
    return {
      id: "",
      careType: 0,
      serviceTypes: [
        {
          icon: require("../../assets/service_type_code.png"),
          name: "屏幕贴膜",
          type: 1,
          supportService: [1]
        },
        {
          icon: require("../../assets/service_type_form.png"),
          name: "更换屏幕/电池/享受延保",
          type: 2,
          supportService: [2, 3, 4]
        }
      ],
      service: []
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    if (!this.$route.params.service) {
      this.loadData();
    } else {
      this.careType = this.$route.params.type;
      this.service = this.$route.params.service;
    }
  },
  methods: {
    async loadData() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetCardInfo", {
          type: "post",
          body: { CardSysNo: this.id }
        });
        if (ret.Status) {
          this.careType = ret.Data.ServiceType;
          this.service = [];
          ret.Data.OrderEquityList.forEach(item => {
            let type = parseInt(item.EquityType);
            let service = {
              type: type,
              use: item.UseTotalNum,
              total: item.EquityTotalCount
            };
            this.service.push(service);
          });
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    gotoType(item) {
      const id = this.$route.params.id;
      let valid = false;
      const service = this.service.toMap(item => ""+item.type);
     

      item.supportService.forEach(index => {
        let s = service["" + index];
        valid = valid || (s && s.use < s.total);
      });
      const params = {
        id: this.id,
        type: this.type,
        service: this.service
      };
      if (!valid) {
        this.goto(`/care/${id}/service/none`);
      } else if (item.type === 1) {
        this.$router.push({
          name: "ServiceCode",
          params: params
        });
      } else if (item.type === 2) {
        this.$router.push({
          name: "ServiceForm",
          params: params
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.types {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
  min-height: 100vh;
  background: #f1f5f8;
}

.item {
  height: 86px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  img {
    height: 68px;
  }
  .item-content {
    margin-left: 16px;
  }

  .name {
    color: black;
    font-size: 14px;
    font-weight: bold;
  }
  .info {
    color: #666666;
    font-size: 12px;
    font-weight: 400;
    margin-top: 8px;
  }
  &[type="1"] {
    background: linear-gradient(to right, #d9ebc8, #f5fcf1);
  }
  &[type="2"] {
    background: linear-gradient(to right, #d4e9f8, #e7f3fb);
  }
}
.item + .item {
  margin-top: 16px;
}
</style>